// hooks/useScrollTo.js
import {useRef, useCallback} from 'react'

/**
 * Simple hook for smooth scrolling to an element
 * @param {number} offset - Offset from top in pixels (default: 80)
 * @returns {Object} { ref, scrollToElement }
 */
export const useScrollTo = (offset = 80) => {
    const elementRef = useRef(null)

    const scrollToElement = useCallback(() => {
        if (elementRef.current) {
            const elementPosition = elementRef.current.offsetTop
            const offsetPosition = Math.max(0, elementPosition - offset)

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            })
        }
    }, [offset])

    return {ref: elementRef, scrollToElement}
}
